import { v4 as uuidv4 } from 'uuid';
export function generateOperationId() {
    return uuidv4();
}
//# sourceMappingURL=operation.js.map